import { Button as BaseButton } from "antd";
import styled from "styled-components";

export const MenuButton = styled(BaseButton)`
  padding: 0 10px;
`;
